import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthFactoryService } from '../../auth/auth-factory.service';
import { RestGenericUtilService } from '../rest-generic-util.service';
import { RestGeneric } from '../rest.generic';
import { SystemSettingsAutoSyncGroups } from './interfaces/system-settings-auto-sync-groups';
import { SystemSettingsAutoSyncGroupsRequest } from './interfaces/system-settings-auto-sync-groups-request';

@Injectable({
  providedIn: 'root'
})
export class SystemSettingsAutoSyncGroupsService extends RestGeneric<any, SystemSettingsAutoSyncGroups, SystemSettingsAutoSyncGroupsRequest> {
  constructor(
    protected http: HttpClient,
    protected authFactoryService: AuthFactoryService,
    protected restGenericUtilService: RestGenericUtilService
  ) {
    super(http, authFactoryService, 'settings/auto-sync-roster', restGenericUtilService);
  }

  getAll(
    filter?: Record<string, any>,
    headers?: Record<string, string>
  ): Observable<SystemSettingsAutoSyncGroups[]> {
    const params = this.restGenericUtilService.toParams({ ...filter });

    return this.http.get<SystemSettingsAutoSyncGroups[]>(`${this.baseApiUrl}/${this.schoolUUid}/${this.endpointName}`, {
      params,
      headers
    });
  }

  getTotalCount(): Observable<any> {
    return this.http
        .get<any>(
            `${this.baseApiUrl}/${this.schoolUUid}/${this.endpointName}`,
            {
              params: {pageSize: 1},
              observe: 'response'
            }
        );
  }

  update(updateType: SystemSettingsAutoSyncGroupsRequest): Observable<SystemSettingsAutoSyncGroups[]> {
    return this.http.put<SystemSettingsAutoSyncGroups[]>(`${this.baseApiUrl}/${this.schoolUUid}/${this.endpointName}`, updateType);
  }
}
